import { Props } from './props'

export const mobilePadding = function ({ columns }: Props) {
  return columns > 1 ? '2%' : 'initial'
}
